import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { postStatus } from '../status';
import { postUpdatePublisher } from 'api';

// Then, handle actions in your reducers:
const updatePublisherSlice = createSlice({
  name: 'updatePublisher',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    updatePublisherPostStart: (state) => {
      state.status = postStatus.POST_START;
      state.fetching = true;
      state.error = false;
    },
    updatePublisherPostSuccess: (state, { payload }) => {
      state.status = postStatus.POST_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = false;
    },
    updatePublisherPostFail: (state, { payload }) => {
      state.status = postStatus.POST_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    updatePublisherPostReset: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
      state.error = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  updatePublisherPostStart,
  updatePublisherPostSuccess,
  updatePublisherPostFail,
  updatePublisherPostReset,
} = updatePublisherSlice.actions;

// The reducer
export const updatePublisherReducer = updatePublisherSlice.reducer;

// Asynchronous thunk action
export const updatePublisherPost = (formData) => (dispatch) => {
  dispatch(updatePublisherPostStart());

  postUpdatePublisher(formData)
    .then((payload) => {
      dispatch(updatePublisherPostSuccess(payload));
    })
    .catch((error) => {
      dispatch(updatePublisherPostFail(error));
    });
};
